angular = require('angular')

module.exports =
  angular.module('App.Components.RefundPolicies', [])
  .component('refundPolicyList', require('./list'))
  .component('refundPolicySave', require('./save'))
  .component('refundPolicyForm', require('./form'))
